
import React from 'react';
import { Interview } from '@/types/interview';
import { Table, TableBody, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import InterviewTableRow from './InterviewTableRow';
import { useTranslation } from 'react-i18next';

interface PendingInterviewsTableProps {
  interviews: Interview[];
  onViewInterview: (interview: Interview) => void;
  onEditInterview: (interview: Interview) => void;
  onPublish: (interviewId: string) => void;
  onSendToFeeder: (interviewId: string) => void;
  onDelete: (interviewId: string) => void;
  publishingId: string | null;
  sendingToFeederId: string | null;
  deletingId: string | null;
}

const PendingInterviewsTable: React.FC<PendingInterviewsTableProps> = ({
  interviews,
  onViewInterview,
  onEditInterview,
  onPublish,
  onSendToFeeder,
  onDelete,
  publishingId,
  sendingToFeederId,
  deletingId
}) => {
  const { t } = useTranslation();
  
  return (
    <div className="bg-white rounded-lg shadow overflow-hidden">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>{t('interviewManagement.interviewee')}</TableHead>
            <TableHead>{t('interviewManagement.submitted')}</TableHead>
            <TableHead>{t('interviewManagement.actions')}</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {interviews.map((interview) => (
            <InterviewTableRow 
              key={interview.id}
              interview={interview}
              onViewInterview={onViewInterview}
              onEditInterview={onEditInterview}
              onPublish={onPublish}
              onSendToFeeder={onSendToFeeder}
              onDelete={onDelete}
              publishingId={publishingId}
              sendingToFeederId={sendingToFeederId}
              deletingId={deletingId}
            />
          ))}
        </TableBody>
      </Table>
    </div>
  );
};

export default PendingInterviewsTable;
